import React from "react";
import { Label } from "reactstrap";
import DatePicker from "react-datepicker";
import { Container, Form, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import CustomReactSelect from "../../../components/CustomReactSelect";
import ButtonLoader from "../../../components/ButtonLoader";
import {
	ExcelBtnClassName,
	ExcelBtnTitle,
} from "../../ticketModule/variables/ListingVariables";

function FilterationBar(props) {
	const {
		employeeList,
		selectedEmployee,
		onEmployeeChange,
		statusList,
		selectedStatus,
		onStatusChange,
		scoreList,
		selectedScore,
		onScoreChange,
		startDate,
		endDate,
		onStartDateChange,
		onEndDateChange,
		exportToExcel,
		handleSubmit,
		showBtnLoading,
		isTableData,
	} = props;
	return (
		<Container fluid className="p-0">
			<Form>
				<Label className="select-criteria-form-title">
					Select Criteria
				</Label>
				<Row className="row-one">
					<Col lg={4}>
						<Form.Group className="d-flex align-items-center m-0">
							<Form.Label className="mb-0 mr-5">
								Employee
							</Form.Label>
							<CustomReactSelect
								options={employeeList}
								onChange={(obj) => onEmployeeChange(obj)}
								value={selectedEmployee}
								className="dropDown"
								placeholder="Select"
							/>
						</Form.Group>
					</Col>
					<Col lg={4}>
						<Form.Group className="d-flex align-items-center m-0">
							<Form.Label className="mb-0 mr-5">Score</Form.Label>
							<CustomReactSelect
								options={scoreList}
								onChange={(obj) => onScoreChange(obj)}
								value={selectedScore}
								className="dropDown"
								placeholder="Select"
							/>
						</Form.Group>
					</Col>
					<Col lg={4}>
						<Form.Group className="d-flex align-items-center m-0">
							<Form.Label className="mb-0 mr-5">
								Status
							</Form.Label>
							<CustomReactSelect
								options={statusList}
								onChange={(obj) => onStatusChange(obj)}
								value={selectedStatus}
								className="dropDown"
								placeholder="Select"
							/>
						</Form.Group>
					</Col>
				</Row>
				<Row className="row-two">
					<Col lg={4}>
						<Form.Group className="d-flex align-items-center m-0">
							<Form.Label className="mb-0 mr-4">
								Start Date
							</Form.Label>
							<Col sm={9} className="datepicker-wrapper ">
								<DatePicker
									showYearDropdown
									showMonthDropdown
									dateFormatCalendar=" " //for title
									dateFormat="dd/MM/yyyy"
									name="lStartDate"
									className="custom-container"
									autoComplete="off"
									onChange={(e) => onStartDateChange(e)}
									selected={startDate}
									maxDate={new Date()}
								/>
								<FontAwesomeIcon
									icon={faCalendarAlt}
									className="calender-icon"
									color="keppel"
								/>
							</Col>
						</Form.Group>
					</Col>
					<Col lg={4}>
						<Form.Group className="d-flex align-items-center m-0">
							<Form.Label className="mb-0 mr-3">
								End Date
							</Form.Label>
							<Col sm={9} className="datepicker-wrapper ">
								<DatePicker
									showYearDropdown
									showMonthDropdown
									dateFormatCalendar=" " //for title
									dateFormat="dd/MM/yyyy"
									className={"custom-container"}
									name="lEndDate"
									selected={endDate}
									onChange={(e) => onEndDateChange(e)}
									minDate={startDate}
									maxDate={new Date()}
									autoComplete="off"
								/>
								<FontAwesomeIcon
									icon={faCalendarAlt}
									className="calender-icon"
									color="keppel"
								/>
							</Col>
						</Form.Group>
					</Col>
				</Row>
				<Row className="criteria-form-btns">
					<Col className="align-items-center d-flex btns-col">
						<input
							type="submit"
							value="Submit"
							className="submit-btn leftBtn"
							onClick={handleSubmit}
						/>
						<ButtonLoader
							className={ExcelBtnClassName}
							disabled={!isTableData || showBtnLoading}
							onClick={exportToExcel}
							btnTitle={ExcelBtnTitle}
							showBtnLoading={showBtnLoading}
						/>
					</Col>
				</Row>
				<div className="clear"></div>
			</Form>
		</Container>
	);
}

export default FilterationBar;
